import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    ColumnChooser,
    Paging,
    Scrolling,
    Export,
    Summary,
    TotalItem,
    GroupPanel,
    Grouping,
    GroupItem,
    Pager,
    FilterRow,
    MasterDetail
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import { Popup } from 'devextreme-react/popup';
import { showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import { parseDate, hasRole } from "../../utils/Utils";
import './MaasOrtalamaRapor.scss';
//import ExcelJS from 'exceljs';
//import saveAs from 'file-saver';
/*
  // Use this import for codeSandBox
  import FileSaver from "file-saver";
*/
import { exportDataGrid } from 'devextreme/excel_exporter';

import DetailTemplate from './MaasOrtalamaRaporDetailTemplate.js';

const MaasOrtalamaRapor = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            maasOrtalamaRaporu: hasRole("yoneticirapor|yoneticirapor|maasOrtalamaRaporu"),
        });

    const listeBasligi = "Meslek Maaş Ortalama Raporu";
    const [store, setStore] = useState(null);



    useEffect(() => {
        setStore(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return []
            }
        }));
    }, [])


    let dataGrid = null;


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                let data = {};
                // data.donems = donemsTemp;
                // data.domains = treeBoxValue;



                const request = new Request("/yoneticiRapor/getKayitList", "POST", data);
                return request.run()
                    .then(response => {

                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {

        setStore(getStore());
    }


    return (
        <div >



            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                </div>
            </div>

            <DataGrid
                className="maasOrtalamaListesiGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                //height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <Grouping autoExpandAll={true} />
                {/* <SearchPanel visible={true} /> */}
                {/* <FilterRow visible={true} /> */}
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true} visible={true} />
                <Paging defaultPageSize={20} />
                <FilterRow visible={true} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'meslekKodu'} width={200} caption={'Melek Kodu'} dataType="string" visible={true} />
                <Column dataField={'meslekAdi'} width={100} caption={'Meslek Adı'} dataType="string" visible={true} />

                {/* <Column dataField="yil" width={70} caption={'Yıl'}   visible={true} />
                <Column dataField={'ortalamaTutar'} width={150} caption={'Ortalama Tutar'} dataType="number" visible={true} />
                <Column dataField={'kisiSayisi'} width={150} caption={'Kişi Sayısı'} dataType="number" visible={true} />
                <Column dataField={'toplamGun'} width={150} caption={'Toplam Gün'} dataType="number" visible={false} />  */}

                <MasterDetail
                    enabled={true}
                    component={DetailTemplate}
                />

            </DataGrid>

        </div>
    )
}

export default MaasOrtalamaRapor;
